// extracted by mini-css-extract-plugin
export default {"container":"CopyToClipboard_container__slHlV","text":"CopyToClipboard_text__IKAjc","logo":"CopyToClipboard_logo__VXGbf","icon":"CopyToClipboard_icon__N9bdw"};